// eslint-disable-next-line no-undef
export const chequeColumnMap: Record<string, string> = {
  'PDC Date': 'pdc_date',
  'Supplier': 'supplier_id',
  'Terms': 'terms',
  'Date Encoded': 'created_at',
  'Amount': 'amount',
  'Visible in Liability': 'liability'
};
